import { RESOURCE } from 'constants/api';
import axios from 'utils/axios';

export const getResources = async (data) => {
    const result = await axios.get(RESOURCE.v2.fetchResources, {
        params: data
    });
    return result.data;
};
